var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('b-nav-item-dropdown',{attrs:{"text":_vm.user.nombres,"right":""}},[_c('b-dropdown-item',{attrs:{"href":"#"}},[_vm._v("¡BIENVENIDO!")]),_c('b-dropdown-item',{attrs:{"variant":"danger"},nativeOn:{"click":function($event){return _vm.closeSesion.apply(null, arguments)}}},[_vm._v("Cerrar Sesión")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }